import serverVars from 'server-vars';
import { getCurrency } from 'dibs-intl/exports/units';
import { localStorage, sessionStorage } from 'dibs-browser-storage';
import {
    isUserNegotiating,
    getCheckoutParam,
    isNegotiableOrder,
    sentMakeOfferModalMessage,
} from './checkoutRedirects';
import { isLoggedIn } from './checkoutUser';
import { STORAGE } from '../constants/checkoutConstants';
import { getGuestUserToken, setGuestUserToken } from './checkoutGuestUserToken';

export function getEmailKey(itemId) {
    return [STORAGE.PREFIX, itemId, STORAGE.HAS_TRACKED_EMAIL].join('_');
}

export function getConfirmationKey(transactionId) {
    return [STORAGE.PREFIX, transactionId, STORAGE.TRACK_CONFIRMATION].join('_');
}

function getConfirmationGuestUserTokenKey(transactionId) {
    return [STORAGE.PREFIX, transactionId, STORAGE.GUEST_USER_TOKEN].join('_');
}

// Set guest user token in session storage after completing guest checkout
export function setConfirmationGuestUserToken(transactionId) {
    const guestUserToken = getGuestUserToken();
    if (guestUserToken) {
        sessionStorage.setItem(getConfirmationGuestUserTokenKey(transactionId), guestUserToken);
    }
}

// On confirmation page, get guest user token from storage and set it in './checkoutGuestUserToken'
export function getAndSetConfirmationGuestUserToken(transactionId) {
    const guestUserToken = sessionStorage.getItem(getConfirmationGuestUserTokenKey(transactionId));
    if (guestUserToken) {
        setGuestUserToken(guestUserToken);
    }
}

export function getTriggerTypeKey(transactionId) {
    return [STORAGE.PREFIX, transactionId, STORAGE.TRIGGER_TYPE].join('_');
}

export function setItemNotAvailable(title) {
    const encodedTitle = encodeURIComponent(title || '');
    window.document.cookie = `${STORAGE.PREFIX}_unavailableItem=${encodedTitle}; path=/; domain=.1stdibs.com`;
}

export function updateStorage({ itemId, itemInfo, isPrivateOffer, isPreAuthNegotiation }) {
    const isNegotiable = isNegotiableOrder();
    const isFullPrice =
        getCheckoutParam('fullPrice') === 'true' ||
        (!isPrivateOffer && !isPreAuthNegotiation && !isNegotiable);

    let orderType;
    if (isPrivateOffer) {
        orderType = 'Private Offer';
    } else if (isPreAuthNegotiation) {
        orderType = 'Negotiations 2.0';
    } else if (isNegotiable) {
        orderType = 'Negotiations 1.5';
    } else {
        orderType = 'Full Price';
    }

    if (isFullPrice) {
        sessionStorage.setItem(STORAGE.AUTO_MODAL_INFO, { item: itemInfo });
    }

    if (!isLoggedIn() && isUserNegotiating() && !sentMakeOfferModalMessage()) {
        sessionStorage.setItem(STORAGE.AUTO_MODAL_OFFER_INFO, {
            item: {
                itemId,
                offerAmount: getCheckoutParam('offerAmount') || '0',
                offerCurrency:
                    getCheckoutParam('offerCurrency') || getCurrency(serverVars.get('locale')),
            },
        });
    }

    localStorage.setItem(STORAGE.SURVEY_INFO, {
        itemId,
        orderType,
        checkoutTime: new Date().toJSON(),
        step: (localStorage.getItem(STORAGE.SURVEY_INFO) || {}).step,
    });
}

export function clearAutoOfferModalData() {
    sessionStorage.deleteItem(STORAGE.AUTO_MODAL_OFFER_INFO);
}
